// extracted by mini-css-extract-plugin
module.exports = {"render":"VSAnlytics_render__hukPh","currentPageButton":"VSAnlytics_currentPageButton__2oijf","nextPageButton":"VSAnlytics_nextPageButton__VWRn0"};